// extracted by mini-css-extract-plugin
export default {"inputGrid":"input-grid_inputGrid__Q-uXp","content":"input-grid_content__eHUqm"};